export default {"src":"/_next/static/media/trust-pilot-micro.77522ca5.svg","height":35,"width":231,"blurWidth":0,"blurHeight":0};